import store from '../../store';

/**
 * Get the plugin download url
 * @returns {string}
 */
export function getPluginUrl() {
  const { state } = store;
  return '';
  // return state.app.pluginUrl
}
